import { Carousel, CarouselItem } from 'react-bootstrap';
import { useState } from 'react';

import { Slide } from '../slider/Slide';
import './UserTutorial.css';
import {
    HelloUserSlideContent,
    HelloUserSlideImage,
    HelloUserSlideImageSrc,
} from './slides/HelloUserSlide';
import {
    GetThingsDoneSlideContent,
    GetThingsDoneSlideImage,
    GetThingsDoneSlideImageSrc,
} from './slides/GetThingsDoneSlide';
import {
    GreatProjectIdeaSlideContent,
    GreatProjectIdeaSlideImage,
    GreatProjectIdeaSlideImageSrc,
} from './slides/GreatProjectIdea';
import {
    EmergencyCaseSlideContent,
    EmergencyCaseSlideImage,
    EmergencyCaseSlideImageSrc,
} from './slides/EmergencyCaseSlide';
import {
    ApprovalReceivedSlideContent,
    ApprovalReceivedSlideImage,
    ApprovalReceivedSlideImageSrc,
} from './slides/ApprovalReceivedSlide';
import {
    AllDoneSlideContent,
    AllDoneSlideImage,
    AllDoneSlideImageSrc,
} from './slides/AllDoneSlide';
import {
    PleaseRememberSlideContent,
    PleaseRememberSlideImage,
    PleaseRememberSlideImageSrc,
} from './slides/PleaseRemember';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';
import { ILocalization } from '../../../../localization/definitions/types';

interface Props {
    closeModal: () => void;
    localization: ILocalization;
}
const UserTutorial = ({ closeModal, localization }: Props) => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };

    const onNextBtnClick = () => {
        handleSelect(index + 1);
    };

    const onBackBtnClick = () => {
        handleSelect(index - 1);
    };

    const onFinishBtnClick = () => {
        closeModal();
    };

    const userSlides = [
        {
            content: <HelloUserSlideContent localization={localization} />,
            image: <HelloUserSlideImage />,
            imgSource: HelloUserSlideImageSrc,
        },
        {
            content: <GetThingsDoneSlideContent localization={localization} />,
            image: <GetThingsDoneSlideImage />,
            imgSource: GetThingsDoneSlideImageSrc,
        },

        {
            content: (
                <GreatProjectIdeaSlideContent localization={localization} />
            ),
            image: <GreatProjectIdeaSlideImage />,
            imgSource: GreatProjectIdeaSlideImageSrc,
        },
        {
            content: <EmergencyCaseSlideContent localization={localization} />,
            image: <EmergencyCaseSlideImage />,
            imgSource: EmergencyCaseSlideImageSrc,
        },
        {
            content: (
                <ApprovalReceivedSlideContent localization={localization} />
            ),
            image: <ApprovalReceivedSlideImage />,
            imgSource: ApprovalReceivedSlideImageSrc,
        },
        {
            content: <AllDoneSlideContent localization={localization} />,
            image: <AllDoneSlideImage />,
            imgSource: AllDoneSlideImageSrc,
        },
        {
            content: <PleaseRememberSlideContent localization={localization} />,
            image: <PleaseRememberSlideImage />,
            imgSource: PleaseRememberSlideImageSrc,
        },
    ];

    const isLastSlide = () => {
        return index === userSlides.length - 1;
    };

    return (
        <div
            className={`${isLastSlide() ? 'hide-dots' : ''} tutorial-carousel`}
            data-testid={'tutorial-slider'}
        >
            <Carousel
                interval={null}
                activeIndex={index}
                onSelect={handleSelect}
            >
                {userSlides.map((slide, i) => (
                    <CarouselItem key={i} data-testid={`slide-${i}`}>
                        <Slide
                            localization={localization}
                            slide={{ ...slide, index: i }}
                            numberOfSlides={userSlides.length}
                            onBackBtnClick={onBackBtnClick}
                            onFinishBtnClick={onFinishBtnClick}
                            onNextBtnClick={onNextBtnClick}
                        />
                    </CarouselItem>
                ))}
            </Carousel>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        localization: state.localization,
    };
};

export default connect(mapStateToProps)(UserTutorial);
